import moment from "moment/moment";

// Safely parse platform from localStorage
let userPlatform = null;
try {
  userPlatform = JSON.parse(localStorage.getItem("user_platform"));
} catch (e) {
  userPlatform = null;
}

function getRangeEndDate(includeToday) {
  return includeToday
    ? moment().endOf("day").toDate()
    : moment().subtract(1, "days").endOf("day").toDate();
}

function isSameDayRange(selectedRange, definedRange) {
  return (
    moment(selectedRange?.startDate).isSame(definedRange?.startDate, "day") &&
    moment(selectedRange?.endDate).isSame(definedRange?.endDate, "day")
  );
}

/** Matches react-date-range createStaticRanges selection behavior */
function createStaticRange({ label, range }) {
  return {
    label,
    range,
    isSelected(selectedRange) {
      return isSameDayRange(selectedRange, range());
    },
  };
}

function buildPlatformSpecificRanges(includeToday = false) {
  const endDate = () => getRangeEndDate(includeToday);

  const lastNDays = (label, daysWithoutToday) =>
    createStaticRange({
      label,
      range: () => ({
        startDate: moment()
          .subtract(includeToday ? daysWithoutToday - 1 : daysWithoutToday, "days")
          .startOf("day")
          .toDate(),
        endDate: endDate(),
      }),
    });

  const thisMonth = createStaticRange({
    label: "This Month",
    range: () => ({
      startDate: moment().startOf("month").toDate(),
      endDate: endDate(),
    }),
  });

  const ranges = [
    lastNDays("Last 7 Days", 7),
    lastNDays("Last 14 Days", 14),
    lastNDays("Last 30 Days", 30),
    lastNDays("Last 90 Days", 90),
    thisMonth,
  ];

  return {
    myntra: ranges,
    amazon: ranges,
    flipkart: ranges,
  };
}

export function getDefaultCalendarDate(includeToday = false) {
  return [
    {
      startDate: moment()
        .subtract(includeToday ? 6 : 7, "days")
        .startOf("day")
        .toDate(),
      endDate: getRangeEndDate(includeToday),
      key: "selection",
    },
  ];
}

export function getTodayCalendarDate() {
  const todayStart = moment().startOf("day").toDate();
  const todayEnd = moment().endOf("day").toDate();
  return [
    {
      startDate: todayStart,
      endDate: todayEnd,
      key: "selection",
    },
  ];
}

export function getDefaultDateRangesWithLabels(includeToday = false) {
  const platformSpecificRanges =
    buildPlatformSpecificRanges(includeToday)?.[userPlatform] ||
    buildPlatformSpecificRanges(includeToday).amazon;

  return [
    createStaticRange({
      label: "Today",
      range: () => ({
        startDate: moment().startOf("day").toDate(),
        endDate: moment().endOf("day").toDate(),
      }),
    }),
    createStaticRange({
      label: "Yesterday",
      range: () => ({
        startDate: moment().subtract(1, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
      }),
    }),
    ...platformSpecificRanges,
    createStaticRange({
      label: "Last Month",
      range: () => ({
        startDate: moment().subtract(1, "month").startOf("month").toDate(),
        endDate: moment().subtract(1, "month").endOf("month").toDate(),
      }),
    }),
    createStaticRange({
      label: "This Year",
      range: () => ({
        startDate: moment().startOf("year").toDate(),
        endDate: includeToday
          ? moment().endOf("day").toDate()
          : moment().subtract(1, "days").endOf("day").toDate(),
      }),
    }),
    createStaticRange({
      label: "Last Year",
      range: () => ({
        startDate: moment().subtract(1, "year").startOf("year").toDate(),
        endDate: moment().subtract(1, "year").endOf("year").toDate(),
      }),
    }),
  ];
}

const defaultDateRangesWithLables = getDefaultDateRangesWithLabels(false);

export default defaultDateRangesWithLables;
